import { render, staticRenderFns } from "./PhdReview.vue?vue&type=template&id=03420938&"
import script from "./PhdReview.vue?vue&type=script&lang=js&"
export * from "./PhdReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports